/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// Core
import React, { MouseEventHandler, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import {
  MobileNavBar,
  HeaderNavToggle,
  StyledSrOnly,
} from './MobileHeaderWrapper.styles';

type MobileHeaderWrapperProps = {
  children: ReactNode;
  isOpen: boolean;
  handleOnClickToggle: MouseEventHandler;
};
const MobileHeaderWrapper = ({
  children,
  isOpen,
  handleOnClickToggle,
}: MobileHeaderWrapperProps) => {
  const { t } = useTranslation();

  return (
    <MobileNavBar>
      <HeaderNavToggle
        type="button"
        id="header-nav-toggle"
        onClick={handleOnClickToggle}
        aria-expanded={isOpen ? 'true' : 'false'}
      >
        <StyledSrOnly>{t('Toggle Navigation')}</StyledSrOnly>
        <span className="sandwich-line" />
        <span className="sandwich-line" />
        <span className="sandwich-line" />
      </HeaderNavToggle>

      {children}
    </MobileNavBar>
  );
};

export default MobileHeaderWrapper;
